import { CARDIO_FIELD_DEFS } from '../../data/sports';
import { useToast } from '../../context/ToastContext';
import { numericProps } from '../../utils/numericInput';

export default function CardioForm({ sport, sportConfig, values, onChange }) {
    const showToast = useToast();
    const fields = sportConfig?.cardioFields || ['distance', 'calories', 'avgHR'];
    const set = (key, val) => onChange({ ...values, [key]: val });
    const np = (key, allowDecimal = false) => numericProps(values[key] || '', v => set(key, v), showToast, { allowDecimal });

    const renderField = (fieldKey) => {
        if (fieldKey === 'interval') {
            return (
                <div key="interval" className="form-group">
                    <label className="form-label">인터벌 구성</label>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                        <input className="form-input" placeholder="운동(초)" style={{ flex: 1, minWidth: 72 }}
                            {...np('intervalWork')} />
                        <span style={{ color: 'var(--text3)', fontSize: 12 }}>초 ×</span>
                        <input className="form-input" placeholder="세트" style={{ flex: 1, minWidth: 56 }}
                            {...np('intervalSets')} />
                        <span style={{ color: 'var(--text3)', fontSize: 12 }}>세트, 휴식</span>
                        <input className="form-input" placeholder="초" style={{ flex: 1, minWidth: 56 }}
                            {...np('intervalRest')} />
                        <span style={{ color: 'var(--text3)', fontSize: 12 }}>초</span>
                    </div>
                </div>
            );
        }

        const def = CARDIO_FIELD_DEFS[fieldKey];
        if (!def) return null;
        const isNumeric = def.type === 'number';
        return (
            <div key={fieldKey} className="form-group">
                <label className="form-label">{def.label}</label>
                <input
                    className="form-input"
                    placeholder={def.placeholder}
                    {...(isNumeric
                        ? np(def.stateKey, !!def.allowDecimal)
                        : { value: values[def.stateKey] || '', onChange: e => set(def.stateKey, e.target.value) }
                    )}
                />
            </div>
        );
    };

    const GRID_PAIRS = [
        ['distance', 'calories'],
        ['avgHR', 'pace'],
        ['avgHR', 'power'],
        ['speed', 'elevation'],
        ['rpm', 'power'],
        ['floors', 'stepRate'],
    ];

    const rendered = new Set();
    const elements = [];

    for (const pair of GRID_PAIRS) {
        const [a, b] = pair;
        if (fields.includes(a) && fields.includes(b) && !rendered.has(a) && !rendered.has(b)) {
            elements.push(
                <div key={`${a}-${b}`} className="metric-grid">
                    {[a, b].map(k => <div key={k} className="form-group" style={{ marginBottom: 0 }}>{renderField(k)}</div>)}
                </div>
            );
            rendered.add(a);
            rendered.add(b);
        }
    }

    for (const fieldKey of fields) {
        if (!rendered.has(fieldKey)) {
            elements.push(renderField(fieldKey));
            rendered.add(fieldKey);
        }
    }

    return (
        <>
            <div className="form-group">
                <label className="form-label">오늘의 목표</label>
                <input
                    className="form-input"
                    placeholder={sportConfig?.focusPlaceholder || '오늘의 목표'}
                    value={values.focus || ''}
                    onChange={e => set('focus', e.target.value)}
                />
            </div>
            {elements}
        </>
    );
}
